export default "__VITE_ASSET__D87c_je9__"